/* Concentración */

const perspectivas = [
  'Productos',
  'Saldo',
  'Depositos a plazo por vencimiento'
]

var Tablim = {
  'tipoNormativa1-1': 'CRE_14',
  'tipoNormativa2-1': 'CRE_15',
  'tipoNormativa3-1': 'CRE_16',
  'tipoNormativa1-2': 'CRE_17',
  'tipoNormativa2-2': 'CRE_18',
  'tipoNormativa3-2': 'CRE_19',
  'genero1-1':'CRE_20',
  'genero2-1':'CRE_21',
  'genero3-1':'CRE_22',
  'genero1-2':'CRE_23',
  'genero2-2':'CRE_24',
  'genero3-2':'CRE_25',
  'bandaMontoOtorgado1-1':'CRE_26',
  'bandaMontoOtorgado2-1':'CRE_27',
  'bandaMontoOtorgado3-1':'CRE_28',
  'bandaMontoOtorgado4-1':'CRE_29',
  'bandaMontoOtorgado5-1':'CRE_30',
  'bandaMontoOtorgado6-1':'CRE_31',
  'bandaMontoOtorgado7-1':'CRE_32',
  'bandaMontoOtorgado1-2':'CRE_33',
  'bandaMontoOtorgado2-2':'CRE_34',
  'bandaMontoOtorgado3-2':'CRE_35',
  'bandaMontoOtorgado4-2':'CRE_36',
  'bandaMontoOtorgado5-2':'CRE_37',
  'bandaMontoOtorgado6-2':'CRE_38',
  'bandaMontoOtorgado7-2':'CRE_39',
  'rangoPlazoOtorgado1-1':'CRE_40',
  'rangoPlazoOtorgado2-1':'CRE_41',
  'rangoPlazoOtorgado3-1':'CRE_42',
  'rangoPlazoOtorgado4-1':'CRE_43',
  'rangoPlazoOtorgado5-1':'CRE_44',
  'rangoPlazoOtorgado1-2':'CRE_45',
  'rangoPlazoOtorgado2-2':'CRE_46',
  'rangoPlazoOtorgado3-2':'CRE_47',
  'rangoPlazoOtorgado4-2':'CRE_48',
  'rangoPlazoOtorgado5-2':'CRE_49',
  'producto1-1':'CRE_50',
  'producto2-1':'CRE_51',
  'producto3-1':'CRE_52',
  'producto4-1':'CRE_53',
  'producto5-1':'CRE_54',
  'producto6-1':'CRE_55',
  'producto7-1':'CRE_56',
  'producto1-2':'CRE_57',
  'producto2-2':'CRE_58',
  'producto3-2':'CRE_59',
  'producto4-2':'CRE_60',
  'producto5-2':'CRE_61',
  'producto6-2':'CRE_62',
  'producto7-2':'CRE_63',
  'tipoGarantia1-1':'CRE_64',
  'tipoGarantia2-1':'CRE_65',
  'tipoGarantia3-1':'CRE_66',
  'tipoGarantia4-1':'CRE_67',
  'tipoGarantia5-1':'CRE_68',
  'tipoGarantia6-1':'CRE_69',
  'tipoGarantia7-1':'CRE_70',
  'tipoGarantia1-2':'CRE_71',
  'tipoGarantia2-2':'CRE_72',
  'tipoGarantia3-2':'CRE_73',
  'tipoGarantia4-2':'CRE_74',
  'tipoGarantia5-2':'CRE_75',
  'tipoGarantia6-2':'CRE_76',
  'tipoGarantia7-2':'CRE_77',
  'sucursal1-1':'CRE_78',
  'sucursal2-1':'CRE_79',
  'sucursal3-1':'CRE_80',
  'sucursal4-1':'CRE_81',
  'sucursal5-1':'CRE_82',
  'sucursal6-1':'CRE_83',
  'sucursal7-1':'CRE_84',
  'sucursal8-1':'CRE_85',
  'sucursal9-1':'CRE_86',
  'sucursal10-1':'CRE_87',
  'sucursal11-1':'CRE_88',
  'sucursal12-1':'CRE_89',
  'sucursal13-1':'CRE_90',
  'sucursal1-2':'CRE_91',
  'sucursal2-2':'CRE_92',
  'sucursal3-2':'CRE_93',
  'sucursal4-2':'CRE_94',
  'sucursal5-2':'CRE_95',
  'sucursal6-2':'CRE_96',
  'sucursal7-2':'CRE_97',
  'sucursal8-2':'CRE_98',
  'sucursal9-2':'CRE_99',
  'sucursal10-2':'CRE_100',
  'sucursal11-2':'CRE_101',
  'sucursal12-2':'CRE_102',
  'sucursal13-2':'CRE_103',
  'region1-1':'CRE_104',
  'region2-1':'CRE_105',
  'region3-1':'CRE_106',
  'region1-2':'CRE_107',
  'region2-2':'CRE_108',
  'region3-2':'CRE_109',
  'tipoPersona1-1':'CRE_110',
  'tipoPersona2-1':'CRE_111',
  'tipoPersona3-1':'CRE_112',
  'tipoPersona1-2':'CRE_113',
  'tipoPersona2-2':'CRE_114',
  'tipoPersona3-2':'CRE_115',
  'nivelAprobacion1-1':'CRE_180',
  'nivelAprobacion2-1':'CRE_181',
  'nivelAprobacion3-1':'CRE_182',
  'nivelAprobacion4-1':'CRE_183',
  'nivelAprobacion5-1':'CRE_184',
  'nivelAprobacion1-2':'CRE_185',
  'nivelAprobacion2-2':'CRE_186',
  'nivelAprobacion3-2':'CRE_187',
  'nivelAprobacion4-2':'CRE_188',
  'nivelAprobacion5-2':'CRE_189',
}

export class limits{
  static getLimit(id){
    return Tablim[id] ?? '';
  }

  static getText(id){
    return tabNames[id] ?? id;
  }
}

var tabNames = {
  "HASTA 12 MESES": "HASTA 12 MESES",
  "MAS DE 12 HASTA 24": "MAS DE 12 HASTA 24 MESES",
  "MAS DE 24 HASTA 36": "MAS DE 24 HASTA 36 MESES",
  "MAS DE 36": "MAS DE 36 MESES",
  "MICROEMPRESARIO": "MICROEMPRESARIAL",
  "REFINANCIACION": "REFINANCIACIÓN",
  "TARJETA DE CREDITO CREDICARD": "TARJETAS",
  "'MICROEMPRESARIO','ORDINARIO','VIVIENDA','REFINANCIACION','PARALELO','TARJETA DE CREDITO CREDICARD'": 'RESTO DE PRODUCTOS',
  "CAAZAPA": "Caazapá",
  "TROCHE": "Mauricio J. Troche",
  "SAN JUAN NEPOMUCENO": "S. Juan Nepomuseno",
  "JUAN L. MALLORQUIN": "J. León Mayorquín",
  "CAAGUAZU": "Caaguazú",
  "CNEL. OVIEDO": "Coronel Ovideo",
}


var indicadores = {
  "CRE_14": { CRE_14: { limits: { min: 0, max: 0 } }, },
  "CRE_15": { CRE_15: { limits: { min: 0, max: 0 } }, },
  "CRE_16": { CRE_16: { limits: { min: 0, max: 0 } }, },
  "CRE_17": { CRE_17: { limits: { min: 0, max: 0 } }, },
  "CRE_18": { CRE_18: { limits: { min: 0, max: 0 } }, },
  "CRE_19": { CRE_19: { limits: { min: 0, max: 0 } }, },
  "CRE_20": { CRE_20: { limits: { min: 0, max: 0 } }, },
  "CRE_21": { CRE_21: { limits: { min: 0, max: 0 } }, },
  "CRE_22": { CRE_22: { limits: { min: 0, max: 0 } }, },
  "CRE_23": { CRE_23: { limits: { min: 0, max: 0 } }, },
  "CRE_24": { CRE_24: { limits: { min: 0, max: 0 } }, },
  "CRE_25": { CRE_25: { limits: { min: 0, max: 0 } }, },
  "CRE_26": { CRE_26: { limits: { min: 0, max: 0 } }, },
  "CRE_27": { CRE_27: { limits: { min: 0, max: 0 } }, },
  "CRE_28": { CRE_28: { limits: { min: 0, max: 0 } }, },
  "CRE_29": { CRE_29: { limits: { min: 0, max: 0 } }, },
  "CRE_30": { CRE_30: { limits: { min: 0, max: 0 } }, },
  "CRE_31": { CRE_31: { limits: { min: 0, max: 0 } }, },
  "CRE_32": { CRE_32: { limits: { min: 0, max: 0 } }, },
  "CRE_33": { CRE_33: { limits: { min: 0, max: 0 } }, },
  "CRE_34": { CRE_34: { limits: { min: 0, max: 0 } }, },
  "CRE_35": { CRE_35: { limits: { min: 0, max: 0 } }, },
  "CRE_36": { CRE_36: { limits: { min: 0, max: 0 } }, },
  "CRE_37": { CRE_37: { limits: { min: 0, max: 0 } }, },
  "CRE_38": { CRE_38: { limits: { min: 0, max: 0 } }, },
  "CRE_39": { CRE_39: { limits: { min: 0, max: 0 } }, },
  "CRE_40": { CRE_40: { limits: { min: 0, max: 0 } }, },
  "CRE_41": { CRE_41: { limits: { min: 0, max: 0 } }, },
  "CRE_42": { CRE_42: { limits: { min: 0, max: 0 } }, },
  "CRE_43": { CRE_43: { limits: { min: 0, max: 0 } }, },
  "CRE_44": { CRE_44: { limits: { min: 0, max: 0 } }, },
  "CRE_45": { CRE_45: { limits: { min: 0, max: 0 } }, },
  "CRE_46": { CRE_46: { limits: { min: 0, max: 0 } }, },
  "CRE_47": { CRE_47: { limits: { min: 0, max: 0 } }, },
  "CRE_48": { CRE_48: { limits: { min: 0, max: 0 } }, },
  "CRE_49": { CRE_49: { limits: { min: 0, max: 0 } }, },
  "CRE_50": { CRE_50: { limits: { min: 0, max: 0 } }, },
  "CRE_51": { CRE_51: { limits: { min: 0, max: 0 } }, },
  "CRE_52": { CRE_52: { limits: { min: 0, max: 0 } }, },
  "CRE_53": { CRE_53: { limits: { min: 0, max: 0 } }, },
  "CRE_54": { CRE_54: { limits: { min: 0, max: 0 } }, },
  "CRE_55": { CRE_55: { limits: { min: 0, max: 0 } }, },
  "CRE_56": { CRE_56: { limits: { min: 0, max: 0 } }, },
  "CRE_57": { CRE_57: { limits: { min: 0, max: 0 } }, },
  "CRE_58": { CRE_58: { limits: { min: 0, max: 0 } }, },
  "CRE_59": { CRE_59: { limits: { min: 0, max: 0 } }, },
  "CRE_60": { CRE_60: { limits: { min: 0, max: 0 } }, },
  "CRE_61": { CRE_61: { limits: { min: 0, max: 0 } }, },
  "CRE_62": { CRE_62: { limits: { min: 0, max: 0 } }, },
  "CRE_63": { CRE_63: { limits: { min: 0, max: 0 } }, },
  "CRE_64": { CRE_64: { limits: { min: 0, max: 0 } }, },
  "CRE_65": { CRE_65: { limits: { min: 0, max: 0 } }, },
  "CRE_66": { CRE_66: { limits: { min: 0, max: 0 } }, },
  "CRE_67": { CRE_67: { limits: { min: 0, max: 0 } }, },
  "CRE_68": { CRE_68: { limits: { min: 0, max: 0 } }, },
  "CRE_69": { CRE_69: { limits: { min: 0, max: 0 } }, },
  "CRE_70": { CRE_70: { limits: { min: 0, max: 0 } }, },
  "CRE_71": { CRE_71: { limits: { min: 0, max: 0 } }, },
  "CRE_72": { CRE_72: { limits: { min: 0, max: 0 } }, },
  "CRE_73": { CRE_73: { limits: { min: 0, max: 0 } }, },
  "CRE_74": { CRE_74: { limits: { min: 0, max: 0 } }, },
  "CRE_75": { CRE_75: { limits: { min: 0, max: 0 } }, },
  "CRE_76": { CRE_76: { limits: { min: 0, max: 0 } }, },
  "CRE_77": { CRE_77: { limits: { min: 0, max: 0 } }, },
  "CRE_78": { CRE_78: { limits: { min: 0, max: 0 } }, },
  "CRE_79": { CRE_79: { limits: { min: 0, max: 0 } }, },
  "CRE_80": { CRE_80: { limits: { min: 0, max: 0 } }, },
  "CRE_81": { CRE_81: { limits: { min: 0, max: 0 } }, },
  "CRE_82": { CRE_82: { limits: { min: 0, max: 0 } }, },
  "CRE_83": { CRE_83: { limits: { min: 0, max: 0 } }, },
  "CRE_84": { CRE_84: { limits: { min: 0, max: 0 } }, },
  "CRE_85": { CRE_85: { limits: { min: 0, max: 0 } }, },
  "CRE_86": { CRE_86: { limits: { min: 0, max: 0 } }, },
  "CRE_87": { CRE_87: { limits: { min: 0, max: 0 } }, },
  "CRE_88": { CRE_88: { limits: { min: 0, max: 0 } }, },
  "CRE_89": { CRE_89: { limits: { min: 0, max: 0 } }, },
  "CRE_90": { CRE_90: { limits: { min: 0, max: 0 } }, },
  "CRE_91": { CRE_91: { limits: { min: 0, max: 0 } }, },
  "CRE_92": { CRE_92: { limits: { min: 0, max: 0 } }, },
  "CRE_93": { CRE_93: { limits: { min: 0, max: 0 } }, },
  "CRE_94": { CRE_94: { limits: { min: 0, max: 0 } }, },
  "CRE_95": { CRE_95: { limits: { min: 0, max: 0 } }, },
  "CRE_96": { CRE_96: { limits: { min: 0, max: 0 } }, },
  "CRE_97": { CRE_97: { limits: { min: 0, max: 0 } }, },
  "CRE_98": { CRE_98: { limits: { min: 0, max: 0 } }, },
  "CRE_99": { CRE_99: { limits: { min: 0, max: 0 } }, },
  "CRE_100": { CRE_100: { limits: { min: 0, max: 0 } }, },
  "CRE_101": { CRE_101: { limits: { min: 0, max: 0 } }, },
  "CRE_102": { CRE_102: { limits: { min: 0, max: 0 } }, },
  "CRE_103": { CRE_103: { limits: { min: 0, max: 0 } }, },
  "CRE_104": { CRE_104: { limits: { min: 0, max: 0 } }, },
  "CRE_105": { CRE_105: { limits: { min: 0, max: 0 } }, },
  "CRE_106": { CRE_106: { limits: { min: 0, max: 0 } }, },
  "CRE_107": { CRE_107: { limits: { min: 0, max: 0 } }, },
  "CRE_108": { CRE_108: { limits: { min: 0, max: 0 } }, },
  "CRE_109": { CRE_109: { limits: { min: 0, max: 0 } }, },
  "CRE_110": { CRE_110: { limits: { min: 0, max: 0 } }, },
  "CRE_111": { CRE_111: { limits: { min: 0, max: 0 } }, },
  "CRE_112": { CRE_112: { limits: { min: 0, max: 0 } }, },
  "CRE_113": { CRE_113: { limits: { min: 0, max: 0 } }, },
  "CRE_114": { CRE_114: { limits: { min: 0, max: 0 } }, },
  "CRE_115": { CRE_115: { limits: { min: 0, max: 0 } }, },
  "CRE_116": { CRE_116: { limits: { min: 0, max: 0 } }, },
  "CRE_117": { CRE_117: { limits: { min: 0, max: 0 } }, },
  "CRE_118": { CRE_118: { limits: { min: 0, max: 0 } }, },
  "CRE_119": { CRE_119: { limits: { min: 0, max: 0 } }, },
  "CRE_120": { CRE_120: { limits: { min: 0, max: 0 } }, },
  "CRE_121": { CRE_121: { limits: { min: 0, max: 0 } }, },
  "CRE_122": { CRE_122: { limits: { min: 0, max: 0 } }, },
  "CRE_123": { CRE_123: { limits: { min: 0, max: 0 } }, },
  "CRE_124": { CRE_124: { limits: { min: 0, max: 0 } }, },
  "CRE_125": { CRE_125: { limits: { min: 0, max: 0 } }, },
  "CRE_126": { CRE_126: { limits: { min: 0, max: 0 } }, },
  "CRE_127": { CRE_127: { limits: { min: 0, max: 0 } }, },
  "CRE_128": { CRE_128: { limits: { min: 0, max: 0 } }, },
  "CRE_129": { CRE_129: { limits: { min: 0, max: 0 } }, },
  "CRE_130": { CRE_130: { limits: { min: 0, max: 0 } }, },
  "CRE_131": { CRE_131: { limits: { min: 0, max: 0 } }, },
  "CRE_132": { CRE_132: { limits: { min: 0, max: 0 } }, },
  "CRE_133": { CRE_133: { limits: { min: 0, max: 0 } }, },
  "CRE_134": { CRE_134: { limits: { min: 0, max: 0 } }, },
  "CRE_135": { CRE_135: { limits: { min: 0, max: 0 } }, },
  "CRE_136": { CRE_136: { limits: { min: 0, max: 0 } }, },
  "CRE_137": { CRE_137: { limits: { min: 0, max: 0 } }, },
  "CRE_138": { CRE_138: { limits: { min: 0, max: 0 } }, },
  "CRE_139": { CRE_139: { limits: { min: 0, max: 0 } }, },
  "CRE_140": { CRE_140: { limits: { min: 0, max: 0 } }, },
  "CRE_141": { CRE_141: { limits: { min: 0, max: 0 } }, },
  "CRE_142": { CRE_142: { limits: { min: 0, max: 0 } }, },
  "CRE_143": { CRE_143: { limits: { min: 0, max: 0 } }, },
  "CRE_144": { CRE_144: { limits: { min: 0, max: 0 } }, },
  "CRE_145": { CRE_145: { limits: { min: 0, max: 0 } }, },
  "CRE_146": { CRE_146: { limits: { min: 0, max: 0 } }, },
  "CRE_147": { CRE_147: { limits: { min: 0, max: 0 } }, },
  "CRE_148": { CRE_148: { limits: { min: 0, max: 0 } }, },
  "CRE_149": { CRE_149: { limits: { min: 0, max: 0 } }, },
  "CRE_150": { CRE_150: { limits: { min: 0, max: 0 } }, },
  "CRE_151": { CRE_151: { limits: { min: 0, max: 0 } }, },
  "CRE_152": { CRE_152: { limits: { min: 0, max: 0 } }, },
  "CRE_153": { CRE_153: { limits: { min: 0, max: 0 } }, },
  "CRE_154": { CRE_154: { limits: { min: 0, max: 0 } }, },
  "CRE_155": { CRE_155: { limits: { min: 0, max: 0 } }, },
  "CRE_156": { CRE_156: { limits: { min: 0, max: 0 } }, },
  "CRE_157": { CRE_157: { limits: { min: 0, max: 0 } }, },
  "CRE_158": { CRE_158: { limits: { min: 0, max: 0 } }, },
  "CRE_159": { CRE_159: { limits: { min: 0, max: 0 } }, },
  "CRE_160": { CRE_160: { limits: { min: 0, max: 0 } }, },
  "CRE_161": { CRE_161: { limits: { min: 0, max: 0 } }, },
  "CRE_162": { CRE_162: { limits: { min: 0, max: 0 } }, },
  "CRE_163": { CRE_163: { limits: { min: 0, max: 0 } }, },
  "CRE_164": { CRE_164: { limits: { min: 0, max: 0 } }, },
  "CRE_165": { CRE_165: { limits: { min: 0, max: 0 } }, },
  "CRE_166": { CRE_166: { limits: { min: 0, max: 0 } }, },
  "CRE_167": { CRE_167: { limits: { min: 0, max: 0 } }, },
  "CRE_168": { CRE_168: { limits: { min: 0, max: 0 } }, },
  "CRE_169": { CRE_169: { limits: { min: 0, max: 0 } }, },
  "CRE_170": { CRE_170: { limits: { min: 0, max: 0 } }, },
  "CRE_171": { CRE_171: { limits: { min: 0, max: 0 } }, },
  "CRE_172": { CRE_172: { limits: { min: 0, max: 0 } }, },
  "CRE_173": { CRE_173: { limits: { min: 0, max: 0 } }, },
  "CRE_174": { CRE_174: { limits: { min: 0, max: 0 } }, },
  "CRE_175": { CRE_175: { limits: { min: 0, max: 0 } }, },
  "CRE_176": { CRE_176: { limits: { min: 0, max: 0 } }, },
  "CRE_177": { CRE_177: { limits: { min: 0, max: 0 } }, },
  "CRE_178": { CRE_178: { limits: { min: 0, max: 0 } }, },
  "CRE_179": { CRE_179: { limits: { min: 0, max: 0 } }, },
  "CRE_180": { CRE_180: { limits: { min: 0, max: 0 } }, },
  "CRE_181": { CRE_181: { limits: { min: 0, max: 0 } }, },
  "CRE_182": { CRE_182: { limits: { min: 0, max: 0 } }, },
  "CRE_183": { CRE_183: { limits: { min: 0, max: 0 } }, },
  "CRE_184": { CRE_184: { limits: { min: 0, max: 0 } }, },
  "CRE_185": { CRE_185: { limits: { min: 0, max: 0 } }, },
  "CRE_186": { CRE_186: { limits: { min: 0, max: 0 } }, },
  "CRE_187": { CRE_187: { limits: { min: 0, max: 0 } }, },
  "CRE_188": { CRE_188: { limits: { min: 0, max: 0 } }, },
  "CRE_189": { CRE_189: { limits: { min: 0, max: 0 } }, },
}

//MAYORES DEUDORES 
export class mayoresDeudores{
  static cuentasAT(plantilla: number){
    var cuentas = {};
    switch(plantilla){
      case 12: 
        cuentas = {
          cuentas: ['P502'],
          varTemp: ['VT11', 'VT22'],
          var: [],
          div: 'VT22',
        }
        return cuentas;
      case 7: 
        cuentas = {
          cuentas: ["P3", "P312", "P313"],
          varTemp: ["VT007"],
          var: [],
          div: 'VT007',
        }
        return cuentas;
      default:
        return '';
          
    }
  }
}

export { perspectivas }